import BackChannelService, {WIDGET_CANCELLATION_SIGNAL} from 'app/services/backChannel/backChannel.service';
import AdminService from "external-services/diary-admin-service/admin.service";
import BookingListFilterService from "external-services/booking-list-filter-service/index";
import BookingsConflicts from "app/services/bookingsConflicts/index";
import DateUtilsService from 'external-services/date-utils-service';
import {BookingAvailabilityService} from 'app/services/LegacyBookingAvailabilityService';
import store from 'appRoot/Store';
import StatusConfigService from "external-services/status-config-service";

const NS = 'BookingsList';

// requiring html templates so that hot reloading works
const template = require('./bookingsList.html');

export default function BookingsList() {
  "ngInject";

  return {
    restrict: 'E',
    controllerAs: 'vm',
    templateUrl: 'app/bookings/list/bookingsList.html',
    bindToController: {
      schedule: '<',
      bookings: '<',
      bookingsByTable: '<',
      affectedBookings: '<',
    },
    scope: true,
    controller
  };

  function controller(
    $scope, $rootScope, $log, $timeout, $window, $filter,
    bookingsCalulationsService, unregister, BookingType
  ) {
    "ngInject";

    const vm = this;
    let bookingChangeCheckInterval;

    const LIST_TYPE_WAITLIST = 'waitlist';
    const LIST_TYPE_BOOKINGS = 'booked';
    const LIST_TYPE_SEATED = 'seated';
    const LIST_TYPE_CANCELLED = 'cancelled';
    const LIST_TYPE_FINISHED = 'finished';
    const LIST_TYPE_ERRORS = 'errors';

    //-- define public properties
    vm.listShown = 'booked';
    vm.statusTypes = {};
    vm.overlapConflicts = [];
    vm.timeConflicts = [];
    vm.tableConflicts = [];
    vm.errors = false;
    vm.cancellations = false;
    vm.cancelClasses = '';
    vm.LIST_TYPES = {
      LIST_TYPE_WAITLIST, LIST_TYPE_BOOKINGS, LIST_TYPE_SEATED,
      LIST_TYPE_CANCELLED, LIST_TYPE_ERRORS, LIST_TYPE_FINISHED
    };
    const timezoneId = AdminService.getVenueTimezoneId();
    const timeNow = DateUtilsService.getVenueTime(timezoneId);
    const currentHour = timeNow.getHours();

    vm.DEFAULT_LIMIT = 30;
    const UPPER_LIMIT = 10000;
    let seatedLoadedMore = false;
    let bookingsLoadedMore = false;
    let waitListLoadedMore = false;

    const BOOKING_TYPE_DESC = '-bookingType';
    const TIME = 'time';
    const BOOKED_AT = 'bookedAt';
    const LAST_NAME = 'lastName';
    const SBWL_SortOrder = [BOOKING_TYPE_DESC, BOOKED_AT, LAST_NAME];
    const Booking_SortOrder = [TIME, LAST_NAME];

    computeCancelClasses();

    //-- define public methods
    vm.switchList = switchList;
    vm.editBooking = editBooking;
    vm.loadMore = loadMore;

    const {statusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
    if (statusOptions?.length) {
      updateStatusTypes();
    } else {
      const unregStatusOptions = store.subscribe(() => {
        const {statusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
        if (statusOptions.length) {
          unregStatusOptions();
          updateStatusTypes();
        }
      });
    }


    //-- listen
    var listeners = [];
    listeners.push($scope.$watch('vm.schedule', scheduleChange));
    listeners.push($scope.$watch('vm.bookings', breakDownBookings));
    listeners.push($scope.$watch('vm.affectedBookings', checkErrors));
    listeners.push($rootScope.$on(WIDGET_CANCELLATION_SIGNAL, highlightCancelledPanel));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    function updateStatusTypes() {
      const {statusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
      statusOptions.forEach(status => {
        if (status.enabled) {
          vm.statusTypes[status.statusType] = true;
        }
      });
    }

    function scheduleChange() {
      vm.standByTablesAvailable = false;
      vm.waitListTablesAvailable = false;
      seatedLoadedMore = false;
      bookingsLoadedMore = false;
      waitListLoadedMore = false;
      vm.limitBookingsTo = vm.listShown === LIST_TYPE_BOOKINGS ? getBookingListLimit() : vm.DEFAULT_LIMIT;
    }

    function highlightCancelledPanel() {
      vm.cancellations = true;
      computeCancelClasses();
    }

    function getBookingListLimit() {
      return vm.currentList && vm.currentList.length > 150 ? 50 : 150;
    }

    function computeCancelClasses() {
      vm.cancelClasses =
        ((vm.listShown == LIST_TYPE_CANCELLED) ? 'selected ' : '') +
        ((vm.cancellations == true) ? 'highlighted-red ' : '');
    }


    /**
     * Break down the bookings by type
     */
    function breakDownBookings(value) {
      vm.isStandbyListEnabled = AdminService.getVenue().standByList;

      if (!value || !vm.bookings) {
        vm.bookingsList = BookingListFilterService.getEmptyCategorisedBookingList();
        switchList(vm.listShown);
        vm.errors = 0;
      } else {
        BookingListFilterService.getCategorisedBookingList(vm.bookings, vm.isStandbyListEnabled)
          .then((bookingsList) => {
            vm.bookingsList = bookingsList;
            vm.standByTablesAvailable = false;
            vm.waitListTablesAvailable = false;
            switchList(vm.listShown);
            requestBookingChangeCheck();
          });
      }

    }

    function requestBookingChangeCheck() {
      $window.clearTimeout(bookingChangeCheckInterval);
      bookingChangeCheckInterval = $window.setTimeout(bookingChangeCheck, 200);
    }

    function bookingChangeCheck() {
      $window.clearTimeout(bookingChangeCheckInterval);
      BookingAvailabilityService.checkWaitListForAvailableTables(vm.schedule, vm.bookingsList.waitlist, vm.bookingsByTable)
        .then(function (waitListBookings) {
          vm.bookingsList.waitlist = (waitListBookings) ? waitListBookings : [];
          if (vm.bookingsList.waitlist) {
            vm.standByTablesAvailable = checkForTablesAvailable(vm.bookingsList.standByListCount);
            vm.waitListTablesAvailable = checkForTablesAvailable(vm.bookingsList.waitListCount);
          }
        });
      BookingsConflicts.checkBookingsForConflicts(vm.bookings).then(function (conflicts) {
        vm.overlapConflicts = conflicts;
        if (conflicts.length > 0) {
          checkErrors();
        }
      });
    }

    function switchList(listType) {
      vm.listShown = listType;

      vm.currentList = BookingListFilterService.getBookingListByListType(listType, vm.bookingsList, vm.affectedBookings);
      changeLimit();

      const serviceStartDate = vm.schedule && vm.schedule.isOpen && vm.schedule.services && vm.schedule.services.length && vm.schedule.services[0].startTime;

      if (serviceStartDate) {
        const now = new Date();
        const isToday = serviceStartDate.getYear() === now.getYear() && serviceStartDate.getMonth() === now.getMonth() && serviceStartDate.getDate() === now.getDate();
        const isCurrentListMoreThanDefaultLimit = vm.listShown === vm.LIST_TYPES.LIST_TYPE_BOOKINGS
          ? vm.currentList?.length > vm.DEFAULT_LIMIT_BOOKINGS
          : vm.currentList?.length > vm.DEFAULT_LIMIT;

        // shortens the list to just bookings from the last 1 hours moving forward
        if (isToday && isCurrentListMoreThanDefaultLimit && vm.limitBookingsTo !== UPPER_LIMIT) {
          const newList = vm.currentList.filter(b => b.time.getHours() >= currentHour - 1);
          vm.optimisedList = newList.length > vm.limitBookingsTo ? newList : getLastLotOfBookings();
        } else {
          vm.optimisedList = null;
        }
      }


      if (listType == LIST_TYPE_CANCELLED) {
        vm.cancellations = false;
      }

      computeCancelClasses();
    }

    /**
     * Counts a collection of bookings backwards until it reaches the limit and returns them in the original order
     */
    function getLastLotOfBookings() {
      const collection = vm.currentList.reverse().filter((b, i) => i < vm.limitBookingsTo).reverse();
      return collection.length ? collection : null;
    }

    function changeLimit() {
      switch (vm.listShown) {
        case LIST_TYPE_WAITLIST:
          vm.limitBookingsTo = waitListLoadedMore ? UPPER_LIMIT : vm.DEFAULT_LIMIT;
          break;

        case LIST_TYPE_BOOKINGS:
          vm.DEFAULT_LIMIT_BOOKINGS = getBookingListLimit();
          vm.limitBookingsTo = bookingsLoadedMore ? UPPER_LIMIT : vm.DEFAULT_LIMIT_BOOKINGS;
          break;

        case LIST_TYPE_SEATED:
          vm.limitBookingsTo = seatedLoadedMore ? UPPER_LIMIT : vm.DEFAULT_LIMIT;
          break;

        default:
          vm.limitBookingsTo = UPPER_LIMIT;
      }
    }

    function loadMore() {

      vm.optimisedList = null;

      switch (vm.listShown) {
        case LIST_TYPE_WAITLIST:
          waitListLoadedMore = true;
          break;

        case LIST_TYPE_BOOKINGS:
          bookingsLoadedMore = true;
          break;

        case LIST_TYPE_SEATED:
          seatedLoadedMore = true;
          break;
      }
      changeLimit();
    }

    function checkErrors() {
      const conflicts = BookingListFilterService.getConflicts(vm.affectedBookings);
      vm.timeConflicts = conflicts.timeConflicts;
      vm.tableConflicts = conflicts.tableConflicts;
      vm.errors = conflicts.timeConflicts.length + conflicts.tableConflicts.length + vm.overlapConflicts.length;
      if (vm.errors === 0 && vm.listShown === LIST_TYPE_ERRORS) {
        switchList(LIST_TYPE_BOOKINGS);
      }
    }

    function checkForTablesAvailable(list = []) {
      return list.some(booking => booking.tablesAvaiable);
    }

    /**
     * [editBooking description]
     * @param  {[type]} evt [description]
     * @return {[type]}         [description]
     */
    function editBooking(evt, booking) {
      $scope.$emit('edit-booking', evt, booking);
    }

  }

}
